var _class, _descriptor, _descriptor2, _DToast, _DToast_brand;
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}
function _classPrivateMethodInitSpec(e, a) {
  _checkPrivateRedeclaration(e, a), a.add(e);
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function _initializerWarningHelper(r, e) {
  throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { and } from "truth-helpers";
import concatClass from "discourse/helpers/concat-class";
import { getMaxAnimationTimeMs } from "discourse/lib/swipe-events";
import swipe from "discourse/modifiers/swipe";
import autoCloseToast from "float-kit/modifiers/auto-close-toast";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
const VELOCITY_THRESHOLD = -1.2;
let DToast = (_class = (_DToast_brand = /*#__PURE__*/new WeakSet(), (_DToast = class DToast extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _DToast_brand);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _initializerDefineProperty(this, "progressBar", _descriptor2, this);
  }
  registerProgressBar(element1) {
    this.progressBar = element1;
  }
  async didSwipe(state1) {
    if (state1.deltaY >= 0) {
      _assertClassBrand(_DToast_brand, this, _animateWrapperPosition).call(this, state1.element, 0);
      return;
    }
    if (state1.velocityY < VELOCITY_THRESHOLD) {
      await _assertClassBrand(_DToast_brand, this, _close).call(this, state1.element);
    } else {
      await _assertClassBrand(_DToast_brand, this, _animateWrapperPosition).call(this, state1.element, state1.deltaY);
    }
  }
  async didEndSwipe(state1) {
    if (state1.velocityY < VELOCITY_THRESHOLD) {
      await _assertClassBrand(_DToast_brand, this, _close).call(this, state1.element);
    } else {
      await _assertClassBrand(_DToast_brand, this, _animateWrapperPosition).call(this, state1.element, 0);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <output
      role={{if @toast.options.autoClose "status" "log"}}
      key={{@toast.id}}
      class={{concatClass "fk-d-toast" @toast.options.class}}
      {{autoCloseToast
        close=@toast.close
        duration=@toast.options.duration
        progressBar=this.progressBar
        enabled=@toast.options.autoClose
      }}
      {{swipe onDidSwipe=this.didSwipe onDidEndSwipe=this.didEndSwipe}}
    >
      <@toast.options.component
        @data={{@toast.options.data}}
        @close={{@toast.close}}
        @showProgressBar={{and
          @toast.options.showProgressBar
          @toast.options.autoClose
        }}
        @onRegisterProgressBar={{this.registerProgressBar}}
      />
    </output>
  
*/
{
  "id": "yMUERBqE",
  "block": "[[[1,\"\\n    \"],[11,\"output\"],[16,\"role\",[52,[30,1,[\"options\",\"autoClose\"]],\"status\",\"log\"]],[16,\"key\",[30,1,[\"id\"]]],[16,0,[28,[32,0],[\"fk-d-toast\",[30,1,[\"options\",\"class\"]]],null]],[4,[32,1],null,[[\"close\",\"duration\",\"progressBar\",\"enabled\"],[[30,1,[\"close\"]],[30,1,[\"options\",\"duration\"]],[30,0,[\"progressBar\"]],[30,1,[\"options\",\"autoClose\"]]]]],[4,[32,2],null,[[\"onDidSwipe\",\"onDidEndSwipe\"],[[30,0,[\"didSwipe\"]],[30,0,[\"didEndSwipe\"]]]]],[12],[1,\"\\n      \"],[8,[30,1,[\"options\",\"component\"]],null,[[\"@data\",\"@close\",\"@showProgressBar\",\"@onRegisterProgressBar\"],[[30,1,[\"options\",\"data\"]],[30,1,[\"close\"]],[28,[32,3],[[30,1,[\"options\",\"showProgressBar\"]],[30,1,[\"options\",\"autoClose\"]]],null],[30,0,[\"registerProgressBar\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[\"@toast\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-toast.js",
  "scope": () => [concatClass, autoCloseToast, swipe, and],
  "isStrictMode": true
}), _DToast), _DToast)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "progressBar", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "registerProgressBar", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerProgressBar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didSwipe", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didSwipe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didEndSwipe", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didEndSwipe"), _class.prototype)), _class);
async function _close(element1) {
  await _assertClassBrand(_DToast_brand, this, _closeWrapperAnimation).call(this, element1);
  this.args.toast.close();
}
async function _closeWrapperAnimation(element1) {
  await element1.animate([{
    transform: "translateY(-150px)"
  }], {
    fill: "forwards",
    duration: getMaxAnimationTimeMs()
  }).finished;
}
async function _animateWrapperPosition(element1, position1) {
  await element1.animate([{
    transform: `translateY(${position1}px)`
  }], {
    fill: "forwards"
  }).finished;
}
export { DToast as default };